var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.583,8.778l-6.453-6.643c-1.729-1.78-4.531-1.78-6.26,0l-6.453,6.643c-1.729,1.78-1.729,4.665,0,6.445l6.453,6.643c1.729,1.78,4.531,1.78,6.26,0l6.453-6.643c1.729-1.78,1.729-4.665,0-6.445ZM16.704,11.896l-3.641,3.748c-.157.161-.365.242-.574.242-.201,0-.402-.075-.558-.226-.316-.308-.324-.814-.017-1.131l2.322-2.39h-4.465v3.77c0,.442-.358.8-.8.8s-.8-.358-.8-.8v-4.569c0-.442.358-.8.8-.8h5.265l-2.437-2.508c-.308-.317-.3-.824.017-1.131.317-.308.823-.3,1.132.016l3.755,3.866c.301.311.301.805,0,1.115Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapRoute);
export default __webpack_public_path__ + "static/media/map-route.479a37f16e1ae9ca9445db114f14f2a2.svg";
export { ForwardRef as ReactComponent };